export enum YandexVerificationQueryEnum {
    YandexVerification = 'yandexActualizationHasError',
}
